export type QualityCaseDetailQueryState = "error" | "loading" | "ready";

/**
 * Case detail must not treat a failed query as still loading. The case object is
 * null on error, so that check has to come after isError.
 */
export function qualityCaseDetailQueryState(input: {
  isError: boolean;
  isPending: boolean;
  hasCase: boolean;
}): QualityCaseDetailQueryState {
  if (input.isError) return "error";
  if (input.isPending || !input.hasCase) return "loading";
  return "ready";
}
